import { AuthenticatedHttp } from '@/http/axios';

/**
 * Impedimentos ativos de emissão de NFS-e do produtor (CKTMF-527), já ordenados
 * por gravidade pelo backend: o primeiro é o que o aviso põe em destaque.
 */
export const getNfseImpediments = async () =>
  AuthenticatedHttp.get('/financial/fiscal-data/nfse-impediments/').then((response) => {
    const impediments = response.data?.impediments;

    return Array.isArray(impediments) ? impediments : [];
  });
